import { useState, useEffect } from "react";
import { RxCrossCircled } from "react-icons/rx";

export default function Select({
  id,
  chapterList,
  deleteSelect,
  setSelectedList,
}) {
  const [selectedChapter, setSelectedChapter] = useState("");
  const [selectedAssignment, setSelectedAssignment] = useState("");

  const [assignmentList, setAssignmentList] = useState([]);

  useEffect(() => {
    setSelectedChapter(chapterList[0]?.name);
  }, [chapterList]);

  useEffect(() => {
    let chapter = chapterList.find(
      (chapter) => chapter.name === selectedChapter
    );
    setAssignmentList(chapter?.assignments || []);
    setSelectedAssignment((chapter?.assignments || [])[0]?.name);

    // eslint-disable-next-line
  }, [selectedChapter]);

  useEffect(() => {
    setSelectedList((prev) => {
      let newArr = prev;
      newArr = newArr.map((item, index) => {
        if (item.id === id) {
          return {
            ...item,
            chapterSelected: selectedChapter,
            assignmentSelected: selectedAssignment,
          };
        }
        return item;
      });
      return newArr;
    });

    // eslint-disable-next-line
  }, [selectedChapter, selectedAssignment]);

  return (
    <div className="grid grid-cols-[20fr_20fr_1fr] gap-3 w-full col-span-2 align-middle">
      <select
        value={selectedChapter}
        onChange={(e) => setSelectedChapter(e.target.value)}
        className="w-full border rounded p-2 mt-1"
      >
        {chapterList.map((chapter, index) => (
          <option key={index} value={chapter.name}>
            {chapter.displayName}
          </option>
        ))}
      </select>
      <select
        value={selectedAssignment}
        onChange={(e) => setSelectedAssignment(e.target.value)}
        className="w-full border rounded p-2 mt-1"
      >
        {assignmentList.map((assignment, index) => (
          <option key={index} value={assignment.name}>
            {assignment.displayName}
          </option>
        ))}
      </select>
      <div className="text-xl flex items-center">
        <button
          className="hover:text-red-500 h-fit transition"
          onClick={() => deleteSelect(id)}
        >
          <RxCrossCircled />
        </button>
      </div>
    </div>
  );
}
